var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"auto-1440"},[_c('Breadcrumb',{attrs:{"title":_vm.title,"type":"grey"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }